import Button from 'components/atoms/button/Button';
import { PiX } from 'react-icons/pi';
import { IChildrenProp, IDiv } from 'types/components/components.interface';
import './MagellanPopupHeader.scss';
import { MouseEvent, MouseEventHandler } from 'react';

interface IMagellanPopupHeaderProps extends IChildrenProp, IDiv {
  onClose?: MouseEventHandler<HTMLButtonElement>;
}

const MagellanPopupHeader = ({
  children,
  onClose,
  className = '',
  ...props
}: IMagellanPopupHeaderProps) => {
  const handleClose = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();

    if (onClose) {
      onClose(e);
      return;
    }

    const overlay = document.querySelector('.popup-overlay');
    if (overlay) (overlay as HTMLElement).click();
  };
  return (
    <div {...props} className={`magellan-popup-header ${className}`}>
      <Button onlyIcon isClear wrapperClassNames="opacity-0 pointer-events-none">
        <PiX />
      </Button>
      <div className="magellan-popup-header-content">{children}</div>
      <Button
        onlyIcon
        isClear
        onClick={handleClose}
        // onClick={() => {
        //   const overlay = document.querySelector('.popup-overlay');
        //   if (overlay) (overlay as HTMLElement).click();
        // }}
      >
        <PiX />
      </Button>
    </div>
  );
};

export default MagellanPopupHeader;
